import React from 'react';
import RichTextRenderer from '../richTextRenderer';
import Image from '../Image';
import InternalExternalLink from '../Link';

// Interfaces
import { Feature as FeatureInterface } from '../../interfaces/feature';

function Feature({ alignment, styleVariation, image, body, link }: FeatureInterface) {
  const WrapperComponent = link ? InternalExternalLink : 'div';
  return (
    <WrapperComponent
      className={`cl-feature cl-feature--${alignment}${
        styleVariation ? ` cl-feature--${styleVariation}` : ''
      }`}
      link={link}
    >
      <Image data={image} />

      <RichTextRenderer text={body} />
    </WrapperComponent>
  );
}

export default Feature;
